class ModdedVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.url || '';
    this.sectionId = this.dataset.section || '';
  }

  connectedCallback() {
    console.log("ModdedVariantPicker connected", this.productUrl, this.sectionId);

    this.addEventListener('change', this.handleVariantChange.bind(this));
  }
  disconnectedCallback() {
    console.log("ModdedVariantPicker disconnected", this.productUrl, this.sectionId);

    this.removeEventListener('change', this.handleVariantChange.bind(this));
  }

  selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
    const params = [];
    !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }
    return `${url}?${params.join('&')}`;
  }

  handleVariantChange(event) {

    if (event.target.tagName === 'SELECT' || event.target.tagName === 'INPUT') {
      const optionValues = this.selectedOptionValues();
      const shouldFetchFullPage = event.target.tagName === 'SELECT';

      const requestUrl = this.buildRequestUrlWithParams(this.productUrl, optionValues, shouldFetchFullPage);

      fetch(requestUrl, {
          method: "GET",
        })
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector(`#${`shopify-section-`+this.sectionId}`);
          
          if (newContent) {
            HTMLUpdateUtility.viewTransition(document.querySelector(`#${`shopify-section-`+this.sectionId}`), newContent);
          } else {
            console.error('New content not found in response');
          }
        })
        .catch(error => console.error('Error fetching variant:', error));
    }

  }
}

if (!customElements.get('modded-variant-picker')) {
  customElements.define('modded-variant-picker', ModdedVariantPicker);
}